import { ColorTokens, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, } from '@voltmoney/schema';
import React, { memo, useEffect, useMemo, useState, } from 'react';
import { Dimensions, Pressable, View, TouchableOpacity } from 'react-native';
import { applyAlignContent, applyAlignSelf, applyBgColor, applyBorder, applyFlex, applyFlexWrap, applyHeight, applyPadding, applyPosition, applyShadow, applyWidth, applyZIndex, } from './utils';
import { Gradient } from '../gradient/Gradient';
import ThemeProvider from '@voltmoney/theme';
/**
 * @description
 * Stack supports children as React Component and widgetItems as WidgetItem Type[order by children -> widgetItems]
 * Note: renderItem should be passed to render WidgetItem
 **/
const Stack = ({ id, type = StackType.column, children, widgetItems = [], renderItem, alignItems = StackAlignItems.flexStart, justifyContent = StackJustifyContent.flexStart, padding = {}, action, triggerAction, onPress, width = StackWidth.CONTENT, height = StackHeight.CONTENT, bgColor = ColorTokens.Transparent, metaData, flexWrap, flex, alignSelf, alignContent, position, positionConfig, borderConfig, zIndex, gradient, shadow, marginRight, marginBottom, borderRadius, widthOfBorder, maxWidth, hide = false, minWidth, maxHeight, minHeight, dimensionAction, setStackClickable, usePressable = false }) => {
    const theme = ThemeProvider.getTheme();
    const windowX = Dimensions.get('window');
    const screenX = Dimensions.get('screen');
    const [dimensions, setDimensions] = useState({
        window: windowX,
        screen: screenX,
    });
    useEffect(() => {
        const subscription = Dimensions.addEventListener('change', ({ window, screen }) => {
            dimensions.window = window;
            dimensions.screen = screen;
            setDimensions({
                ...dimensions,
            });
        });
        return () => subscription?.remove();
    }, []);
    const stackStyle = useMemo(() => {
        return [
            {
                flexDirection: type,
                justifyContent: justifyContent,
                alignItems: alignItems,
                marginBottom: theme.paddingSize[marginBottom],
                marginRight: theme.paddingSize[marginRight],
                backgroundColor: theme.colors[bgColor],
            },
            applyBgColor(bgColor),
            applyPadding(padding),
            applyFlexWrap(flexWrap),
            applyFlex(flex),
            applyAlignSelf(alignSelf),
            applyAlignContent(alignContent),
            applyPosition(position, positionConfig),
            applyBorder(borderConfig),
            applyZIndex(zIndex),
            applyShadow(shadow),
            applyWidth(width, metaData?.widthScreen ||
                dimensions.screen.width),
            applyHeight(height, metaData?.heightScreen ||
                dimensions.screen.height),
            maxWidth ? {
                maxWidth: maxWidth
            } : {},
            minWidth ? {
                minWidth: minWidth
            } : {},
            maxHeight ? {
                maxHeight: maxHeight
            } : {},
            minHeight ? {
                minHeight: minHeight
            } : {},
        ];
    }, [
        justifyContent,
        alignItems,
        type,
        width,
        height,
        bgColor,
        padding,
        metaData,
        flexWrap,
        flex,
        alignSelf,
        alignContent,
        position,
        positionConfig,
        borderConfig,
        zIndex,
        shadow,
        hide,
        maxWidth,
        minWidth,
        maxHeight,
        minHeight
    ]);
    const content = (React.createElement(React.Fragment, null,
        children,
        renderItem && widgetItems.map(renderItem)));
    const handleAction = async () => {
        onPress && onPress();
        action &&
            triggerAction &&
            (await triggerAction(action));
    };
    const handleLayout = (event) => {
        const { width, height } = event.nativeEvent.layout;
        if (triggerAction && dimensionAction) {
            triggerAction({
                ...dimensionAction,
                payload: {
                    ...dimensionAction.payload,
                    width: width,
                    height: height
                },
            });
        }
    };
    return hide ? null : action || onPress ? (gradient?.colors?.length > 1 ? (React.createElement(Gradient, { ...gradient },
        React.createElement(Pressable, { onPress: handleAction, nativeID: id },
            React.createElement(View, { pointerEvents: 'none', style: stackStyle }, content)))) : usePressable ? (React.createElement(Pressable, { onPress: handleAction },
        React.createElement(View, { pointerEvents: 'none', style: stackStyle }, content))) : (React.createElement(TouchableOpacity, { activeOpacity: setStackClickable ? 0 : 1, onPress: handleAction },
        React.createElement(View, { pointerEvents: 'none', style: stackStyle }, content)))) : gradient?.colors?.length > 1 ? (React.createElement(Gradient, { ...gradient },
        React.createElement(View, { nativeID: id, style: stackStyle }, content))) : (dimensionAction ?
        React.createElement(View, { nativeID: id, style: stackStyle, onLayout: handleLayout }, content) :
        React.createElement(View, { nativeID: id, style: stackStyle }, content));
};
export default memo(Stack);
export { Stack };
